<template>
    <div id="app">
        <!-- <router-view /> -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
const SmartCity = window.SmartCity
export default {
    created() {
        SmartCity.interactivePopDisabled("1");
        SmartCity.hideTopView({
            isShow: 0,
        });
    },
}
</script>
<style lang="less" scoped>
#app{
    min-height: 100vh;
}
</style>
